import { SHARED_FILTERS } from './send-mail-stepper-shared-filters';

export const SEND_MAIL_STEPPER_FILTERS = {
  path: '/mailing/stepper',
  filters: SHARED_FILTERS
}; 